import { inject, bindable, BindingEngine } from 'aurelia-framework';
import { DialogService } from 'aurelia-dialog';
import { ProcessService } from 'pages/standard-setup/processes/service';
import { MachineService } from 'pages/standard-setup/machines/service';
import { PartSizeService } from 'pages/standard-setup/part-sizes/service';
import { StandardService } from 'pages/standard-setup/standards/service';
import toastr from 'toastr';

@inject(BindingEngine, ProcessService, MachineService, PartSizeService, DialogService, StandardService)
export class BreakPoint {
    @bindable standard;
    @bindable group;
    @bindable index;

    constructor(bindingEngine, processService, machineService, partSizeService, dialogService, standardService) {
        this.processService = processService;
        this.machineService = machineService;
        this.partSizeService = partSizeService;
        this.bindingEngine = bindingEngine;
        this.dialogService = dialogService;
        this.standardService = standardService;
    }

    async attached () {
        if (this.group.processId != null) {
            this.process = await this.processService.getById(this.group.processId);
        }

        if (this.group.machineId != null) {
            this.machine = await this.machineService.getById(this.group.machineId);
        }

        this.bindingEngine.propertyObserver(this.group, 'processId')
            .subscribe(async (newValue, oldValue) => {
                if (newValue != null) {
                    this.process = await this.processService.getById(newValue);
                } else {
                    this.process = null;
                }
            });

        this.bindingEngine.propertyObserver(this.group, 'machineId')
            .subscribe(async (newValue, oldValue) => {
                if (newValue != null) {
                    this.machine = await this.machineService.getById(newValue);
                } else {
                    this.machine = null;
                }
            });
    }

    addProcess () {
        this.dialogService.open({ viewModel: this.processService.editor });
    }

    addMachine () {
        this.dialogService.open({ viewModel: this.machineService.editor });
    }

    addPartSize () {
        this.dialogService.open({ viewModel: this.partSizeService.editor });
    }

    attemptRemoveGroup (index) {
        this.group.isRemoving = true;
        setTimeout(() => {
            try {
                this.group.isRemoving = false;
            } catch {}
        }, 1500);
    }

    async removeGroup () {
        await this.standardService.deleteGroup(this.group.id);
        this.standard.groups.splice(this.index, 1);
    }

    addItem () {
        let message = '';
        if (this.group.processId == null) {
            message = 'Add a process before adding a breakpoint';
        }

        if (this.standard.workCenter === 'STAMPING' && this.group.machineId == null) {
            message += message.length > 0 ? '<br />' : '';
            message += 'Add a machine before adding a breakpoint';
        }

        if (message.length > 0) {
            toastr.error(message);
            return;
        }

        this.group.items.push({});
    }

    removeItem (groupIndex, itemIndex) {
      this.standard.groups[groupIndex].items.splice(itemIndex, 1);
    }
}
